import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
/**
 * The SoundTransform class contains properties for volume and panning.
 *
 */
var SoundTransform = /** @class */ (function (_super) {
    __extends(SoundTransform, _super);
    /**
     * Creates a SoundTransform object.
     * @param	vol	The volume, ranging from 0 (silent) to 1 (full volume).
     * @param	panning	The left-to-right panning of the sound, ranging from -1 (full pan left)
     *   to 1 (full pan right). A value of 0 represents no panning (center).
     * @langversion	3.0
     * @playerversion	Flash 9
     * @playerversion	Lite 4
     * @refpath
     */
    function SoundTransform(vol, panning) {
        if (vol === void 0) { vol = 1; }
        if (panning === void 0) { panning = 0; }
        var _this = _super.call(this) || this;
        _this._vol = 1;
        _this._pan = 0;
        _this._vol = vol;
        _this._pan = panning;
        return _this;
    }
    // for AVM1:
    SoundTransform.prototype.axCallPublicProperty = function (value1, value2) {
        console.log('axCallPublicProperty not implemented yet in flash/SoundTransform');
        return null;
    };
    SoundTransform.prototype.axGetPublicProperty = function (value) {
        console.log('axGetPublicProperty not implemented yet in flash/SoundTransform');
        return null;
    };
    SoundTransform.prototype.axSetPublicProperty = function (value, value2) {
        console.log('axSetPublicProperty not implemented yet in flash/SoundTransform');
        return null;
    };
    SoundTransform.prototype.axHasPublicProperty = function (value) {
        console.log('axHasPublicProperty not implemented yet in flash/SoundTransform');
        return null;
    };
    SoundTransform.prototype.axDeletePublicProperty = function (value) {
        console.log('axDeletePublicProperty not implemented yet in flash/SoundTransform');
        return null;
    };
    SoundTransform.prototype.axGetEnumerableKeys = function () {
        console.log('axGetEnumerableKeys not implemented yet in flash/SoundTransform');
        return [];
    };
    Object.defineProperty(SoundTransform.prototype, "leftToLeft", {
        /**
         * A value, from 0 (none) to 1 (all), specifying how much of the left input is played in the
         * left speaker.
         */
        get: function () {
            console.log('leftToLeft not implemented yet in flash/SoundTransform');
            return 0;
        },
        set: function (leftToLeft) {
            console.log('leftToLeft not implemented yet in flash/SoundTransform');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundTransform.prototype, "leftToRight", {
        /**
         * A value, from 0 (none) to 1 (all), specifying how much of the left input is played in the
         * right speaker.
         */
        get: function () {
            console.log('leftToRight not implemented yet in flash/SoundTransform');
            return 0;
        },
        set: function (leftToRight) {
            console.log('leftToRight not implemented yet in flash/SoundTransform');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundTransform.prototype, "pan", {
        /**
         * The left-to-right panning of the sound, ranging from -1 (full pan left)
         * to 1 (full pan right). A value of 0 represents no panning (balanced center between
         * right and left).
         */
        get: function () {
            return this._pan;
        },
        set: function (value) {
            this._pan = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundTransform.prototype, "rightToLeft", {
        /**
         * A value, from 0 (none) to 1 (all), specifying how much of the right input is played in the
         * left speaker.
         */
        get: function () {
            console.log('rightToLeft not implemented yet in flash/SoundTransform');
            return 0;
        },
        set: function (rightToLeft) {
            console.log('rightToLeft not implemented yet in flash/SoundTransform');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundTransform.prototype, "rightToRight", {
        /**
         * A value, from 0 (none) to 1 (all), specifying how much of the right input is played in the
         * right speaker.
         */
        get: function () {
            console.log('rightToRight not implemented yet in flash/SoundTransform');
            return 0;
        },
        set: function (rightToRight) {
            console.log('rightToRight not implemented yet in flash/SoundTransform');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundTransform.prototype, "volume", {
        /**
         * The volume, ranging from 0 (silent) to 1 (full volume).
         */
        get: function () {
            return this._vol;
        },
        set: function (value) {
            this._vol = (value > 1)
                ? 1
                : (value < 0 ? 0 : value);
        },
        enumerable: true,
        configurable: true
    });
    return SoundTransform;
}(ASObject));
export { SoundTransform };
